export namespace UserEnums {
    export enum Role {
        Admin = "admin",
        Editor = "editor",
        Viewer = "viewer",
    }

    export enum RoleMode {
        Write = "write",
        Read = "read",
        Admin = "admin",
    }
}